import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/personalDates'

export default function * requestRemovePersonalDate (action) {
  const { id } = action.payload

  const state = yield select()

  const currentPersonalDate = state.kanbo.personalDates.byId[id]

  if (!currentPersonalDate) return

  const optimisticAction = yield optimisticPut(remove({
    id
  }))

  try {
    yield call(apiAction, 'RemovePersonalDate', {
      id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
